import React from "react";
import { SEO, AgentsMain, AdminLayout } from "../../../components";

const AgentsMainPage = () => {
  return (
    <>
      <SEO title="Agents" />
      <AdminLayout>
        <AgentsMain />
      </AdminLayout>
    </>
  );
};

export default AgentsMainPage;
